import React from 'react'

import './DropdownSelector.scss'
import { IconChevDown } from './icons'

function DropdownSelector<T extends string = string> (props: {
  options: readonly DropdownSelector.Item<T>[]
  onSelect: (item: DropdownSelector.Item<T> | null) => void
  selected: T | null
}) {
  const { options, onSelect, selected } = props

  return (
    <select
      onChange={(e) => onSelect(options.find(it => it.key === (e.target.value as T)) ?? null)}
      value={selected ?? undefined}
      style={{
        backgroundImage: `url(${IconChevDown})`
      }}
    >
      {
        options.map(opt => (
          <option
            key={opt.key}
            value={opt.key}
          >
            {opt.label}
          </option>
        ))
      }
    </select>
  )
}

/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable no-redeclare */
declare namespace DropdownSelector {
  export interface Item<T extends string> {
    label: React.ReactNode
    key: T
  }
}

export default DropdownSelector
